import { render, staticRenderFns } from "./CoreDrawer.vue?vue&type=template&id=def69a4e"
import script from "./CoreDrawer.vue?vue&type=script&lang=js"
export * from "./CoreDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports